export const getEmptyPage = <T>() => ({
  totalPages: 0,
  totalElements: 0,
  pageable: {
    paged: false,
    unpaged: false,
    pageNumber: 0,
    pageSize: 0,
    offset: 0,
    sort: {},
  },
  numberOfElements: 0,
  size: 0,
  content: [] as T[],
  number: 0,
  sort: {},
  first: false,
  last: false,
  empty: false,
});
